import { render, staticRenderFns } from "./edit-action-group.vue?vue&type=template&id=7680162e"
import script from "./edit-action-group.ts?vue&type=script&lang=js&external"
export * from "./edit-action-group.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports